export default __webpack_public_path__ + "assets/images/43e4c29aac4e744b939da5b9c1ebea2b.webp";